import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Masters from "@/pages/Masters";
import Customers from "@/pages/Customers";
import Suppliers from "@/pages/Suppliers";
import Inventory from "@/pages/Inventory";
import POS from "@/pages/POS";
import OldGold from "@/pages/OldGold";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Activity from "@/pages/Activity";
import Purchases from "@/pages/Purchases";
import Schemes from "@/pages/Schemes";
import Transfers from "@/pages/Transfers";
import Orders from "@/pages/Orders";
import Repairs from "@/pages/Repairs";
import GST from "@/pages/GST";
import Manufacturing from "@/pages/Manufacturing";
import MetalLedger from "@/pages/MetalLedger";
import RFID from "@/pages/RFID";
import Accounting from "@/pages/Accounting";
import Sales from "@/pages/Sales";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  background: "hsl(var(--card))",
                  color: "hsl(var(--foreground))",
                  border: "1px solid hsl(var(--border))",
                },
              }}
            />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Shell><Dashboard /></Shell>} />
              <Route path="/pos" element={<Shell><POS /></Shell>} />
              <Route path="/inventory" element={<Shell><Inventory /></Shell>} />
              <Route path="/customers" element={<Shell><Customers /></Shell>} />
              <Route path="/suppliers" element={<Shell><Suppliers /></Shell>} />
              <Route path="/old-gold" element={<Shell><OldGold /></Shell>} />
              <Route path="/reports" element={<Shell><Reports /></Shell>} />
              <Route path="/masters" element={<Shell><Masters /></Shell>} />
              <Route path="/users" element={<Shell><Users /></Shell>} />
              <Route path="/activity" element={<Shell><Activity /></Shell>} />
              <Route path="/settings" element={<Shell><Settings /></Shell>} />
              <Route path="/purchases" element={<Shell><Purchases /></Shell>} />
              <Route path="/schemes" element={<Shell><Schemes /></Shell>} />
              <Route path="/transfers" element={<Shell><Transfers /></Shell>} />
              <Route path="/orders" element={<Shell><Orders /></Shell>} />
              <Route path="/repairs" element={<Shell><Repairs /></Shell>} />
              <Route path="/gst" element={<Shell><GST /></Shell>} />
              <Route path="/manufacturing" element={<Shell><Manufacturing /></Shell>} />
              <Route path="/metal-ledger" element={<Shell><MetalLedger /></Shell>} />
              <Route path="/rfid" element={<Shell><RFID /></Shell>} />
              <Route path="/accounting" element={<Shell><Accounting /></Shell>} />
              <Route path="/sales" element={<Shell><Sales /></Shell>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
